export const environment = {
	production: false,
	cloudflareTurnstileSiteKey: '0x4AAAAAACVblxE8FpqORbHW',
};
